import React from 'react'
import styled from 'react-emotion'
import Modal from 'components/Modal'
import Content from './Content'

const CannedRepliesModal = ({ className, hideModal, modalLeft, ...rest }) => {
  return (
    <Modal
      onBackgroundClick={hideModal}
      styleContainer={{ left: modalLeft }}
      contentClass={className}
    >
      <Content hideModal={hideModal} {...rest} />
    </Modal>
  )
}

export default styled(CannedRepliesModal)`
  display: flex;
`
